import { render, staticRenderFns } from "./HoroscopeShow.vue?vue&type=template&id=664d6086&scoped=true&"
import script from "./HoroscopeShow.vue?vue&type=script&lang=js&"
export * from "./HoroscopeShow.vue?vue&type=script&lang=js&"
import style0 from "./HoroscopeShow.vue?vue&type=style&index=0&id=664d6086&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d6086",
  null
  
)

export default component.exports